export default __webpack_public_path__ + "tapIntegrativePage.f3612db60dbbdaaea7d3.png";